import {useQuery} from '@apollo/client';
import {PHARMACY_USERS} from "../pharmacyTypeDefs";

export const useQueryPharmacyUsers = (options?: any): any => (
  useQuery(PHARMACY_USERS, options)
);
